// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ShopSupplierListResultModel from '../../model/shop-supplier-list-result-model';
import ShopSupplierListResultDTO from '../dto/shop-supplier-list-result-dto';
import dtoSchema from '../schemas/shop-supplier-list-result-schema';
import ShopSupplierModel from '../../model/shop-supplier-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class ShopSupplierListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ShopSupplierListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ShopSupplierModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: ShopSupplierModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<ShopSupplierListResultDTO>): ShopSupplierListResultModel;
  static toModel(dto: DeepPartial<ShopSupplierListResultDTO> | undefined | null): ShopSupplierListResultModel | undefined;
  static toModel(dto: DeepPartial<ShopSupplierListResultDTO> | undefined | null): ShopSupplierListResultModel | undefined {
    return dto ? new ShopSupplierListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ShopSupplierListResultModel> | ShopSupplierListResultModel): ShopSupplierListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as ShopSupplierListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ShopSupplierListResultModel, can not map to ShopSupplierListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
